import React, { useState, useRef, useEffect } from "react";
import Airsearch from "./AirportSearch";
import { layDanhSachSanBay } from "../../services/flightService";
import Select from "react-select";
import CustomDateInput from "../CustomDateInput";

export default function FlightSearch({
  isDropdownOpen,
  toggleDropdown,
  passengerCounts,
  updatePassengerCount,
  getTotalPassengers,
  handleSubmitSearch,
}) {
  // State cho danh sách sân bay và modal chọn sân bay
  const [airportList, setAirportList] = useState([]);
  const [showAirportModal, setShowAirportModal] = useState(false);
  const [selectingField, setSelectingField] = useState(null); // 'from' hoặc 'to'

  // Lấy danh sách sân bay (fetch 1 lần khi mount)
  useEffect(() => {
    const fetchAirports = async () => {
      try {
        const data = await layDanhSachSanBay();
        if (data.code === 200) {
          setAirportList(data.data || []);
        }
      } catch (error) {
        setAirportList([]);
      }
    };

    fetchAirports();
  }, []);

  // Callback khi chọn sân bay từ modal
  const handleSelectAirport = (airport) => {
    if (selectingField === "from") {
      setFrom({
        code: airport.code,
        label: airport.label,
        country: airport.country,
      });
      setFromError("");
      // Nếu chọn from trùng với to thì reset to
      if (airport.code === to.code) {
        setTo({
          code: "",
          label: "",
          country: "",
        });
      }
    } else if (selectingField === "to") {
      setTo({
        code: airport.code,
        label: airport.label,
        country: airport.country,
      });
      setToError("");
      // Nếu chọn to trùng với from thì reset from
      if (airport.code === from.code) {
        setFrom({
          code: "",
          label: "",
          country: "",
        });
      }
    }
    setShowAirportModal(false);
    setSelectingField(null);
  };
  const [activeTab, setActiveTab] = useState("oneway");

  // Thêm state cho ngày đi và ngày về
  const [departureDateError, setDepartureDateError] = useState("");
  const [returnDateError, setReturnDateError] = useState("");

  // State cho các trường nhập và lỗi
  const [from, setFrom] = useState({
    code: "HAN",
    label: "Hà Nội (HAN)",
    country: "Việt Nam",
  });
  const [to, setTo] = useState({
    code: "SGN",
    label: "Hồ Chí Minh (SGN)",
    country: "Việt Nam",
  });
  const [fromError, setFromError] = useState("");
  const [toError, setToError] = useState("");

  // State cho lỗi hành khách
  const [passengerError, setPassengerError] = useState("");

  // Ref cho dropdown passenger
  const passengerDropdownRef = useRef(null);

  // Đóng dropdown khi click ra ngoài

  useEffect(() => {
    if (!isDropdownOpen) return;
    const handleClickOutside = (event) => {
      if (
        passengerDropdownRef.current &&
        !passengerDropdownRef.current.contains(event.target)
      ) {
        toggleDropdown();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen, toggleDropdown]);

  // Hàm lấy thứ trong tuần từ ngày
  const getDayOfWeek = (dateStr) => {
    if (!dateStr) return "";
    const days = [
      "Chủ nhật",
      "Thứ hai",
      "Thứ ba",
      "Thứ tư",
      "Thứ năm",
      "Thứ sáu",
      "Thứ bảy",
    ];
    const d = new Date(dateStr);
    if (isNaN(d)) return "";
    return days[d.getDay()];
  };

  // Lấy ngày hiện tại ở định dạng yyyy-mm-dd
  const getToday = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const todayStr = getToday();

  // Thêm giá trị mặc định là ngày hiện tại
  const [departureDate, setDepartureDate] = useState(todayStr);
  const [returnDate, setReturnDate] = useState(todayStr);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // Xử lý thay đổi trường "From"

  // Khi click input sẽ mở modal chọn sân bay
  const handleFromInputClick = () => {
    setSelectingField("from");
    setShowAirportModal(true);
  };
  const handleToInputClick = () => {
    setSelectingField("to");
    setShowAirportModal(true);
  };

  // Sửa lại hàm setDepartureDate để kiểm tra ngày về
  const handleDepartureDateChange = (value) => {
    setDepartureDate(value);
    // Kiểm tra ngày hợp lệ và >= hôm nay
    if (!value || isNaN(new Date(value)) || value < todayStr) {
      setDepartureDateError("Ngày đi không hợp lệ");
    } else {
      setDepartureDateError("");
    }
    if (value > returnDate) {
      setReturnDate(value);
      setReturnDateError("");
    }
  };

  const handleReturnDateChange = (value) => {
    setReturnDate(value);
    // Kiểm tra ngày hợp lệ và >= ngày đi
    if (!value || isNaN(new Date(value)) || value < departureDate) {
      setReturnDateError("Ngày về không hợp lệ hoặc nhỏ hơn ngày đi");
    } else {
      setReturnDateError("");
    }
  };

  // State for age selects
  const [childrenAges, setChildrenAges] = useState([]);
  const [infantAges, setInfantAges] = useState([]);
  const [childrenAgeError, setChildrenAgeError] = useState("");
  const [infantAgeError, setInfantAgeError] = useState("");

  // Options for age selects
  const childrenAgeOptions = Array.from({ length: 10 }, (_, i) => ({
    value: i + 2,
    label: `${i + 2}`,
  }));
  const infantAgeOptions = [
    { value: 0, label: "0" },
    { value: 1, label: "1" },
  ];

  // Reset age fields when passenger count or from/to changes
  useEffect(() => {
    setChildrenAges(Array(passengerCounts.children).fill(null));
    setInfantAges(Array(passengerCounts.infants).fill(null));
    setChildrenAgeError("");
    setInfantAgeError("");
  }, [passengerCounts.children, passengerCounts.infants, from, to]);

  // Check if need to show age selects
  const isForeign = from.country !== "Việt Nam" || to.country !== "Việt Nam";

  // Handle age select change
  const handleChildAgeChange = (idx, selected) => {
    const arr = [...childrenAges];
    arr[idx] = selected;
    setChildrenAges(arr);
    setChildrenAgeError("");
  };
  const handleInfantAgeChange = (idx, selected) => {
    const arr = [...infantAges];
    arr[idx] = selected;
    setInfantAges(arr);
    setInfantAgeError("");
  };

  // Xử lý nút Search
  const handleSearch = (e) => {
    e.preventDefault();
    let valid = true;

    // Reset lỗi
    setFromError("");
    setToError("");
    setDepartureDateError("");
    setReturnDateError("");
    setPassengerError("");
    setChildrenAgeError("");
    setInfantAgeError("");

    // Kiểm tra trường "From"
    if (!from.code.trim()) {
      setFromError("Vui lòng nhập điểm đi");
      valid = false;
    }
    // Kiểm tra trường "To"
    if (!to.code.trim()) {
      setToError("Vui lòng nhập điểm đến");
      valid = false;
    }
    // Kiểm tra ngày đi
    if (
      !departureDate ||
      isNaN(new Date(departureDate)) ||
      departureDate < todayStr
    ) {
      setDepartureDateError("Ngày đi không hợp lệ hoặc nhỏ hơn ngày hiện tại");
      valid = false;
    }
    // Nếu roundtrip thì kiểm tra ngày về
    if (activeTab === "roundtrip") {
      if (
        !returnDate ||
        isNaN(new Date(returnDate)) ||
        returnDate < departureDate
      ) {
        setReturnDateError("Ngày về không hợp lệ hoặc nhỏ hơn ngày đi");
        valid = false;
      }
    }
    // Kiểm tra hành khách: ít nhất phải có 1 người lớn
    if (!passengerCounts.adults || passengerCounts.adults < 1) {
      setPassengerError("Phải có ít nhất 1 người lớn");
      valid = false;
    } else if (passengerCounts.adults < passengerCounts.infants) {
      setPassengerError(
        "Số lượng người lớn phải lớn hơn hoặc bằng số lượng em bé"
      );
      valid = false;
    } else if (passengerCounts.adults + passengerCounts.children > 12) {
      setPassengerError("Tổng số người lớn và trẻ em không được vượt quá 12");
      valid = false;
    }
    // Validate age selects if needed
    if (isForeign) {
      if (
        childrenAges.length !== passengerCounts.children ||
        childrenAges.some((a) => !a)
      ) {
        setChildrenAgeError("Vui lòng chọn tuổi cho tất cả trẻ em");
        valid = false;
      }
      if (
        infantAges.length !== passengerCounts.infants ||
        infantAges.some((a) => !a)
      ) {
        setInfantAgeError("Vui lòng chọn tuổi cho tất cả em bé");
        valid = false;
      }
    }

    if (valid) {
      // Build tuoiHanhKhach array if needed
      let tuoiHanhKhach = [];
      if (isForeign) {
        // Người lớn
        for (let i = 0; i < passengerCounts.adults; ++i) {
          tuoiHanhKhach.push({ loai_hanh_khach: 1, tuoi: 0 });
        }
        // Trẻ em
        childrenAges.forEach((a) => {
          tuoiHanhKhach.push({ loai_hanh_khach: 2, tuoi: a.value });
        });
        // Em bé
        infantAges.forEach((a) => {
          tuoiHanhKhach.push({ loai_hanh_khach: 3, tuoi: a.value });
        });
      }
      handleSubmitSearch({
        from,
        to,
        departureDate,
        returnDate: activeTab === "roundtrip" ? returnDate : null,
        passengerCounts,
        type: activeTab,
        ...(isForeign ? { tuoiHanhKhach } : {}),
      });
    }
  };

  // Xử lý thay đổi số lượng hành khách, loại bỏ lỗi khi hợp lệ
  const handlePassengerChange = (type, action) => {
    updatePassengerCount(type, action);
    if (type === "adults") {
      // Tính số người lớn mới sau khi thay đổi
      const newAdults =
        action === "add"
          ? passengerCounts.adults + 1
          : Math.max(0, passengerCounts.adults - 1);
      if (newAdults > 0) setPassengerError("");
    }
  };

  // Hoán đổi điểm đi và điểm đến (bao gồm cả label)
  const handleSwapFromTo = () => {
    setFrom(to);
    setTo(from);
    // Xóa lỗi nếu swap thành hợp lệ
    if (to.code.trim()) setFromError("");
    if (from.code.trim()) setToError("");
  };

  return (
    <section
      id="theme_search_form_tour"
      className="fligth_top_search_main_form_wrapper"
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="theme_search_form_area">
              <div className="row">
                <div className="col-lg-12">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="flight_categories_search">
                        <ul className="nav nav-tabs" role="tablist">
                          <li className="nav-item" role="presentation">
                            <button
                              className={`nav-link${
                                activeTab === "oneway" ? " active" : ""
                              }`}
                              id="oneway-tab"
                              type="button"
                              role="tab"
                              aria-controls="oneway_flight"
                              aria-selected={activeTab === "oneway"}
                              onClick={() => handleTabClick("oneway")}
                            >
                              Một Chiều
                            </button>
                          </li>
                          <li className="nav-item" role="presentation">
                            <button
                              className={`nav-link${
                                activeTab === "roundtrip" ? " active" : ""
                              }`}
                              id="roundtrip-tab"
                              type="button"
                              role="tab"
                              aria-controls="roundtrip"
                              aria-selected={activeTab === "roundtrip"}
                              onClick={() => handleTabClick("roundtrip")}
                            >
                              Khứ hồi
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="tab-content" id="myTabContent1">
                    {/* One Way Tab */}
                    {activeTab === "oneway" && (
                      <div
                        className="tab-pane fade show active"
                        id="oneway_flight"
                        role="tabpanel"
                        aria-labelledby="oneway-tab"
                      >
                        {/* ...existing code for oneway form... */}
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="oneway_search_form">
                              <form onSubmit={handleSearch}>
                                <div className="row">
                                  <div className="col-lg-3 col-md-6 col-sm-12 col-12">
                                    <div className="flight_Search_boxed">
                                      <p>Điểm đi</p>
                                      <input
                                        type="text"
                                        value={from.code}
                                        readOnly
                                        onClick={handleFromInputClick}
                                        style={{ cursor: "pointer" }}
                                      />
                                      <span>{from.label}</span>
                                      <div className="plan_icon_posation">
                                        <i className="fas fa-plane-departure"></i>
                                      </div>
                                    </div>
                                    {fromError && (
                                      <div
                                        className="mt-1 ms-1"
                                        style={{ color: "red", fontSize: 12 }}
                                      >
                                        {fromError}
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-lg-3 col-md-6 col-sm-12 col-12">
                                    <div className="flight_Search_boxed">
                                      <p>Điểm đến</p>
                                      <input
                                        type="text"
                                        value={to.code}
                                        readOnly
                                        onClick={handleToInputClick}
                                        style={{ cursor: "pointer" }}
                                      />
                                      <span>{to.label}</span>
                                      <div className="plan_icon_posation">
                                        <i className="fas fa-plane-arrival"></i>
                                      </div>
                                      <div
                                        className="range_plan"
                                        onClick={handleSwapFromTo}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <i className="fas fa-exchange-alt"></i>
                                      </div>
                                    </div>
                                    {toError && (
                                      <div
                                        className="mt-1 ms-1"
                                        style={{ color: "red", fontSize: 12 }}
                                      >
                                        {toError}
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                                    <div className="form_search_date">
                                      <div className="flight_Search_boxed date_flex_area">
                                        <div className="Journey_date">
                                          <p>Ngày đi</p>
                                          <CustomDateInput
                                            value={departureDate}
                                            onChange={handleDepartureDateChange}
                                            placeholder="Chọn ngày đi"
                                            minDate={new Date()}
                                          />
                                          <span>
                                            {getDayOfWeek(departureDate)}
                                          </span>
                                        </div>
                                      </div>
                                      {departureDateError && (
                                        <div
                                          className="mt-1 ms-1"
                                          style={{ color: "red", fontSize: 12 }}
                                        >
                                          {departureDateError}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-lg-2 col-md-6 col-sm-12 col-12">
                                    <div className="flight_Search_boxed dropdown_passenger_area">
                                      <p>Hành khách </p>
                                      <div
                                        className="dropdown"
                                        ref={passengerDropdownRef}
                                      >
                                        <button
                                          className="dropdown-toggle final-count"
                                          type="button"
                                          onClick={toggleDropdown}
                                          aria-expanded={isDropdownOpen}
                                        >
                                          {getTotalPassengers()} hành khách
                                        </button>
                                        <span
                                          style={{
                                            display: "block",
                                            fontSize: 12,
                                            color: "#555",
                                          }}
                                        >
                                          {`Người lớn: ${passengerCounts.adults}, Trẻ em: ${passengerCounts.children}, Em bé: ${passengerCounts.infants}`}
                                        </span>
                                        <div
                                          className={`dropdown-menu dropdown_passenger_info ${
                                            isDropdownOpen ? "show" : ""
                                          }`}
                                          style={{
                                            top: 0,
                                            display: isDropdownOpen
                                              ? "block"
                                              : "none",
                                          }}
                                        >
                                          <div className="traveller-calulate-persons">
                                            <div className="passengers">
                                              <h6>Hành khách</h6>
                                              <div className="passengers-types">
                                                <div className="passengers-type">
                                                  <div className="text">
                                                    <span className="count pcount">
                                                      {passengerCounts.adults}
                                                    </span>
                                                    <div className="type-label">
                                                      <p>Người lớn</p>
                                                      <span>12+ tuổi</span>
                                                    </div>
                                                  </div>
                                                  <div className="button-set">
                                                    <button
                                                      type="button"
                                                      className="btn-add"
                                                      onClick={() =>
                                                        handlePassengerChange(
                                                          "adults",
                                                          "add"
                                                        )
                                                      }
                                                    >
                                                      <i className="fas fa-plus"></i>
                                                    </button>
                                                    <button
                                                      type="button"
                                                      className="btn-subtract"
                                                      onClick={() =>
                                                        handlePassengerChange(
                                                          "adults",
                                                          "subtract"
                                                        )
                                                      }
                                                    >
                                                      <i className="fas fa-minus"></i>
                                                    </button>
                                                  </div>
                                                </div>
                                                <div className="passengers-type">
                                                  <div className="text">
                                                    <span className="count ccount">
                                                      {passengerCounts.children}
                                                    </span>
                                                    <div className="type-label">
                                                      <p className="fz14 mb-xs-0">
                                                        Trẻ em
                                                      </p>
                                                      <span>2 - 11 tuổi</span>
                                                    </div>
                                                  </div>
                                                  <div className="button-set">
                                                    <button
                                                      type="button"
                                                      className="btn-add-c"
                                                      onClick={() =>
                                                        handlePassengerChange(
                                                          "children",
                                                          "add"
                                                        )
                                                      }
                                                    >
                                                      <i className="fas fa-plus"></i>
                                                    </button>
                                                    <button
                                                      type="button"
                                                      className="btn-subtract-c"
                                                      onClick={() =>
                                                        handlePassengerChange(
                                                          "children",
                                                          "subtract"
                                                        )
                                                      }
                                                    >
                                                      <i className="fas fa-minus"></i>
                                                    </button>
                                                  </div>
                                                </div>
                                                <div className="passengers-type">
                                                  <div className="text">
                                                    <span className="count incount">
                                                      {passengerCounts.infants}
                                                    </span>
                                                    <div className="type-label">
                                                      <p className="fz14 mb-xs-0">
                                                        Em bé{" "}
                                                      </p>
                                                      <span>Dưới 2 tuổi</span>
                                                    </div>
                                                  </div>
                                                  <div className="button-set">
                                                    <button
                                                      type="button"
                                                      className="btn-add-in"
                                                      onClick={() =>
                                                        handlePassengerChange(
                                                          "infants",
                                                          "add"
                                                        )
                                                      }
                                                    >
                                                      <i className="fas fa-plus"></i>
                                                    </button>
                                                    <button
                                                      type="button"
                                                      className="btn-subtract-in"
                                                      onClick={() =>
                                                        handlePassengerChange(
                                                          "infants",
                                                          "subtract"
                                                        )
                                                      }
                                                    >
                                                      <i className="fas fa-minus"></i>
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {passengerError && (
                                      <div
                                        className="mt-1 ms-1"
                                        style={{ color: "red", fontSize: 12 }}
                                      >
                                        {passengerError}
                                      </div>
                                    )}
                                  </div>
                                  {/* Age selects for foreign route */}
                                  {isForeign && (
                                    <div className="col-lg-12">
                                      <div
                                        style={{
                                          marginTop: 10,
                                          marginBottom: 10,
                                        }}
                                      >
                                        {passengerCounts.children > 0 && (
                                          <div>
                                            <label>
                                              <b>Chọn tuổi cho từng trẻ em:</b>
                                            </label>
                                            <div
                                              style={{
                                                display: "flex",
                                                gap: 8,
                                                flexWrap: "wrap",
                                              }}
                                            >
                                              {childrenAges.map((age, idx) => (
                                                <div
                                                  key={idx}
                                                  style={{ minWidth: 120 }}
                                                >
                                                  <Select
                                                    name={`tuoi_tre_em_${
                                                      idx + 1
                                                    }`}
                                                    options={childrenAgeOptions}
                                                    value={age}
                                                    onChange={(selected) =>
                                                      handleChildAgeChange(
                                                        idx,
                                                        selected
                                                      )
                                                    }
                                                    placeholder={`Trẻ em ${
                                                      idx + 1
                                                    }`}
                                                    isSearchable={false}
                                                    menuPortalTarget={
                                                      document.body
                                                    }
                                                    styles={{
                                                      menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                      }),
                                                    }}
                                                  />
                                                </div>
                                              ))}
                                            </div>
                                            {childrenAgeError && (
                                              <div
                                                style={{
                                                  color: "red",
                                                  fontSize: 12,
                                                  marginTop: 5,
                                                }}
                                              >
                                                {childrenAgeError}
                                              </div>
                                            )}
                                          </div>
                                        )}
                                        {passengerCounts.infants > 0 && (
                                          <div style={{ marginTop: 10 }}>
                                            <label>
                                              <b>Chọn tuổi cho từng em bé:</b>
                                            </label>
                                            <div
                                              style={{
                                                display: "flex",
                                                gap: 8,
                                                flexWrap: "wrap",
                                              }}
                                            >
                                              {infantAges.map((age, idx) => (
                                                <div
                                                  key={idx}
                                                  style={{ minWidth: 120 }}
                                                >
                                                  <Select
                                                    name={`tuoi_em_be_${
                                                      idx + 1
                                                    }`}
                                                    options={infantAgeOptions}
                                                    value={age}
                                                    onChange={(selected) =>
                                                      handleInfantAgeChange(
                                                        idx,
                                                        selected
                                                      )
                                                    }
                                                    placeholder={`Em bé ${
                                                      idx + 1
                                                    }`}
                                                    isSearchable={false}
                                                    menuPortalTarget={
                                                      document.body
                                                    }
                                                    styles={{
                                                      menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                      }),
                                                    }}
                                                  />
                                                </div>
                                              ))}
                                            </div>
                                            {infantAgeError && (
                                              <div
                                                style={{
                                                  color: "red",
                                                  fontSize: 12,
                                                  marginTop: 5,
                                                }}
                                              >
                                                {infantAgeError}
                                              </div>
                                            )}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                  <div className="top_form_search_button">
                                    <button
                                      className="btn btn_theme btn_md"
                                      type="submit"
                                    >
                                      Tìm chuyến
                                    </button>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {/* Roundtrip Tab */}
                    {activeTab === "roundtrip" && (
                      <div
                        className="tab-pane fade show active"
                        id="roundtrip"
                        role="tabpanel"
                        aria-labelledby="roundtrip-tab"
                      >
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="oneway_search_form">
                              <form onSubmit={handleSearch}>
                                <div className="row">
                                  <div className="col-lg-3 col-md-6 col-sm-12 col-12">
                                    <div className="flight_Search_boxed">
                                      <p>Điểm đi</p>
                                      <input
                                        type="text"
                                        value={from.code}
                                        readOnly
                                        onClick={handleFromInputClick}
                                        style={{ cursor: "pointer" }}
                                      />
                                      <span>{from.label}</span>
                                      <div className="plan_icon_posation">
                                        <i className="fas fa-plane-departure"></i>
                                      </div>
                                    </div>
                                    {fromError && (
                                      <div
                                        className="mt-1 ms-1"
                                        style={{ color: "red", fontSize: 12 }}
                                      >
                                        {fromError}
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-lg-3 col-md-6 col-sm-12 col-12">
                                    <div className="flight_Search_boxed">
                                      <p>Điểm đến</p>
                                      <input
                                        type="text"
                                        value={to.code}
                                        readOnly
                                        onClick={handleToInputClick}
                                        style={{ cursor: "pointer" }}
                                      />
                                      <span>{to.label}</span>
                                      <div className="plan_icon_posation">
                                        <i className="fas fa-plane-arrival"></i>
                                      </div>
                                      <div
                                        className="range_plan"
                                        onClick={handleSwapFromTo}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <i className="fas fa-exchange-alt"></i>
                                      </div>
                                    </div>
                                    {toError && (
                                      <div
                                        className="mt-1 ms-1"
                                        style={{ color: "red", fontSize: 12 }}
                                      >
                                        {toError}
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                                    <div className="form_search_date">
                                      <div className="flight_Search_boxed date_flex_area">
                                        <div className="Journey_date">
                                          <p>Ngày đi</p>
                                          <CustomDateInput
                                            value={departureDate}
                                            onChange={handleDepartureDateChange}
                                            placeholder="Chọn ngày đi"
                                            minDate={new Date()}
                                          />
                                          <span>
                                            {getDayOfWeek(departureDate)}
                                          </span>
                                        </div>
                                        <div className="Journey_date">
                                          <p>Ngày về</p>
                                          <CustomDateInput
                                            value={returnDate}
                                            onChange={handleReturnDateChange}
                                            placeholder="Chọn ngày về"
                                            minDate={new Date(departureDate)}
                                          />
                                          <span>
                                            {getDayOfWeek(returnDate)}
                                          </span>
                                          {returnDateError && (
                                            <div
                                              style={{
                                                color: "red",
                                                fontSize: 12,
                                              }}
                                            >
                                              {returnDateError}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      {departureDateError && (
                                        <div
                                          className="mt-1 ms-1"
                                          style={{ color: "red", fontSize: 12 }}
                                        >
                                          {departureDateError}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-lg-2 col-md-6 col-sm-12 col-12">
                                    <div className="flight_Search_boxed dropdown_passenger_area">
                                      <p>Hành khách </p>
                                      <div
                                        className="dropdown"
                                        ref={passengerDropdownRef}
                                      >
                                        <button
                                          className="dropdown-toggle final-count"
                                          type="button"
                                          onClick={toggleDropdown}
                                          aria-expanded={isDropdownOpen}
                                        >
                                          {getTotalPassengers()} hành khách
                                        </button>
                                        <span
                                          style={{
                                            display: "block",
                                            fontSize: 12,
                                            color: "#555",
                                          }}
                                        >
                                          {`Người lớn: ${passengerCounts.adults}, Trẻ em: ${passengerCounts.children}, Em bé: ${passengerCounts.infants}`}
                                        </span>
                                        <div
                                          className={`dropdown-menu dropdown_passenger_info ${
                                            isDropdownOpen ? "show" : ""
                                          }`}
                                          style={{
                                            top: 0,
                                            display: isDropdownOpen
                                              ? "block"
                                              : "none",
                                          }}
                                        >
                                          <div className="traveller-calulate-persons">
                                            <div className="passengers">
                                              <h6>Hành khách</h6>
                                              <div className="passengers-types">
                                                <div className="passengers-type">
                                                  <div className="text">
                                                    <span className="count pcount">
                                                      {passengerCounts.adults}
                                                    </span>
                                                    <div className="type-label">
                                                      <p>Người lớn</p>
                                                      <span>12+ tuổi</span>
                                                    </div>
                                                  </div>
                                                  <div className="button-set">
                                                    <button
                                                      type="button"
                                                      className="btn-add"
                                                      onClick={() =>
                                                        handlePassengerChange(
                                                          "adults",
                                                          "add"
                                                        )
                                                      }
                                                    >
                                                      <i className="fas fa-plus"></i>
                                                    </button>
                                                    <button
                                                      type="button"
                                                      className="btn-subtract"
                                                      onClick={() =>
                                                        handlePassengerChange(
                                                          "adults",
                                                          "subtract"
                                                        )
                                                      }
                                                    >
                                                      <i className="fas fa-minus"></i>
                                                    </button>
                                                  </div>
                                                </div>
                                                <div className="passengers-type">
                                                  <div className="text">
                                                    <span className="count ccount">
                                                      {passengerCounts.children}
                                                    </span>
                                                    <div className="type-label">
                                                      <p className="fz14 mb-xs-0">
                                                        Trẻ em
                                                      </p>
                                                      <span>2 - 11 tuổi</span>
                                                    </div>
                                                  </div>
                                                  <div className="button-set">
                                                    <button
                                                      type="button"
                                                      className="btn-add-c"
                                                      onClick={() =>
                                                        handlePassengerChange(
                                                          "children",
                                                          "add"
                                                        )
                                                      }
                                                    >
                                                      <i className="fas fa-plus"></i>
                                                    </button>
                                                    <button
                                                      type="button"
                                                      className="btn-subtract-c"
                                                      onClick={() =>
                                                        handlePassengerChange(
                                                          "children",
                                                          "subtract"
                                                        )
                                                      }
                                                    >
                                                      <i className="fas fa-minus"></i>
                                                    </button>
                                                  </div>
                                                </div>
                                                <div className="passengers-type">
                                                  <div className="text">
                                                    <span className="count incount">
                                                      {passengerCounts.infants}
                                                    </span>
                                                    <div className="type-label">
                                                      <p className="fz14 mb-xs-0">
                                                        Em bé{" "}
                                                      </p>
                                                      <span>Dưới 2 tuổi</span>
                                                    </div>
                                                  </div>
                                                  <div className="button-set">
                                                    <button
                                                      type="button"
                                                      className="btn-add-in"
                                                      onClick={() =>
                                                        handlePassengerChange(
                                                          "infants",
                                                          "add"
                                                        )
                                                      }
                                                    >
                                                      <i className="fas fa-plus"></i>
                                                    </button>
                                                    <button
                                                      type="button"
                                                      className="btn-subtract-in"
                                                      onClick={() =>
                                                        handlePassengerChange(
                                                          "infants",
                                                          "subtract"
                                                        )
                                                      }
                                                    >
                                                      <i className="fas fa-minus"></i>
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {passengerError && (
                                      <div
                                        className="mt-1 ms-1"
                                        style={{ color: "red", fontSize: 12 }}
                                      >
                                        {passengerError}
                                      </div>
                                    )}
                                  </div>
                                  {/* Age selects for foreign route */}
                                  {isForeign && (
                                    <div className="col-lg-12">
                                      <div
                                        style={{
                                          marginTop: 10,
                                          marginBottom: 10,
                                        }}
                                      >
                                        {passengerCounts.children > 0 && (
                                          <div>
                                            <label>
                                              <b>Chọn tuổi cho từng trẻ em:</b>
                                            </label>
                                            <div
                                              style={{
                                                display: "flex",
                                                gap: 8,
                                                flexWrap: "wrap",
                                              }}
                                            >
                                              {childrenAges.map((age, idx) => (
                                                <div
                                                  key={idx}
                                                  style={{ minWidth: 120 }}
                                                >
                                                  <Select
                                                    name={`tuoi_tre_em_${
                                                      idx + 1
                                                    }`}
                                                    options={childrenAgeOptions}
                                                    value={age}
                                                    onChange={(selected) =>
                                                      handleChildAgeChange(
                                                        idx,
                                                        selected
                                                      )
                                                    }
                                                    placeholder={`Trẻ em ${
                                                      idx + 1
                                                    }`}
                                                    isSearchable={false}
                                                    menuPortalTarget={
                                                      document.body
                                                    }
                                                    styles={{
                                                      menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                      }),
                                                    }}
                                                  />
                                                </div>
                                              ))}
                                            </div>
                                            {childrenAgeError && (
                                              <div
                                                style={{
                                                  color: "red",
                                                  fontSize: 12,
                                                  marginTop: 5,
                                                }}
                                              >
                                                {childrenAgeError}
                                              </div>
                                            )}
                                          </div>
                                        )}
                                        {passengerCounts.infants > 0 && (
                                          <div style={{ marginTop: 10 }}>
                                            <label>
                                              <b>Chọn tuổi cho từng em bé:</b>
                                            </label>
                                            <div
                                              style={{
                                                display: "flex",
                                                gap: 8,
                                                flexWrap: "wrap",
                                              }}
                                            >
                                              {infantAges.map((age, idx) => (
                                                <div
                                                  key={idx}
                                                  style={{ minWidth: 120 }}
                                                >
                                                  <Select
                                                    name={`tuoi_em_be_${
                                                      idx + 1
                                                    }`}
                                                    options={infantAgeOptions}
                                                    value={age}
                                                    onChange={(selected) =>
                                                      handleInfantAgeChange(
                                                        idx,
                                                        selected
                                                      )
                                                    }
                                                    placeholder={`Em bé ${
                                                      idx + 1
                                                    }`}
                                                    isSearchable={false}
                                                    menuPortalTarget={
                                                      document.body
                                                    }
                                                    styles={{
                                                      menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                      }),
                                                    }}
                                                  />
                                                </div>
                                              ))}
                                            </div>
                                            {infantAgeError && (
                                              <div
                                                style={{
                                                  color: "red",
                                                  fontSize: 12,
                                                  marginTop: 5,
                                                }}
                                              >
                                                {infantAgeError}
                                              </div>
                                            )}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                  <div className="top_form_search_button">
                                    <button
                                      className="btn btn_theme btn_md"
                                      type="submit"
                                    >
                                      Tìm chuyến
                                    </button>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Modal chọn sân bay đặt ở ngoài cùng section để luôn hiển thị đúng */}
      {showAirportModal && (
        <div
          style={{
            position: "fixed",
            left: 0,
            top: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.3)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "10px",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 8,
              padding: "15px 20px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.25)",
              width: "100%",
              maxWidth: "650px",
              maxHeight: "90vh",
              // overflow: "auto",
              position: "relative",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "15px",
                borderBottom: "1px solid #eee",
                paddingBottom: "10px",
              }}
            >
              <h4 style={{ margin: 0, fontSize: "18px", fontWeight: "650" }}>
                {selectingField === "from" ? "Chọn điểm đi" : "Chọn điểm đến"}
              </h4>
              <button
                className="btn btn-outline-secondary btn-sm"
                onClick={() => setShowAirportModal(false)}
                style={{
                  borderRadius: "50%",
                  width: "35px",
                  height: "35px",
                  padding: "0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "16px",
                }}
              >
                ×
              </button>
            </div>
            <div style={{ minHeight: "200px" }}>
              <Airsearch
                airportList={airportList}
                onSelect={handleSelectAirport}
                selectingField={selectingField}
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
